/**
 * @generated SignedSource<<8cb1d9b76572b9b38e57ecf28c80ffe1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RuleSubruleUpdateInputObject = {
  destinationAccountName?: string | null | undefined;
  destinationBankAccountId?: string | null | undefined;
  enabled?: boolean | null | undefined;
  matchKind?: string | null | undefined;
  perspectiveId?: string | null | undefined;
  priority?: number | null | undefined;
  stakeholderId?: string | null | undefined;
  subruleId: string;
  valuePattern?: string | null | undefined;
};
export type ruleDetailPage_SubruleUpdateMutation$variables = {
  input: RuleSubruleUpdateInputObject;
};
export type ruleDetailPage_SubruleUpdateMutation$data = {
  readonly ruleSubruleUpdate: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly rule: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type ruleDetailPage_SubruleUpdateMutation = {
  response: ruleDetailPage_SubruleUpdateMutation$data;
  variables: ruleDetailPage_SubruleUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Rule",
  "kind": "LinkedField",
  "name": "rule",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ruleDetailPage_SubruleUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleSubruleUpdateMutationPayload",
        "kind": "LinkedField",
        "name": "ruleSubruleUpdate",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ruleDetailPage_SubruleUpdateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "RuleSubruleUpdateMutationPayload",
        "kind": "LinkedField",
        "name": "ruleSubruleUpdate",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a0e9e8fc574dcf871be107e11aa74a7",
    "id": null,
    "metadata": {},
    "name": "ruleDetailPage_SubruleUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation ruleDetailPage_SubruleUpdateMutation(\n  $input: RuleSubruleUpdateInputObject!\n) {\n  ruleSubruleUpdate(input: $input) {\n    rule {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a5293b02827af998f753befcd9075b6a";

export default node;
